export default "__VITE_ASSET__5809f9ce__"